/**
 * Lista de profesiones colombianas para autocompletado.
 * El usuario puede seleccionar una de la lista o escribir una personalizada.
 */
export const PROFESIONES: string[] = [
  // Ciencias de la Salud
  'AUXILIAR DE ENFERMERÍA',
  'AUXILIAR DE SALUD ORAL',
  'BACTERIÓLOGO',
  'ENFERMERO',
  'FONOAUDIÓLOGO',
  'FISIOTERAPEUTA',
  'INSTRUMENTADOR QUIRÚRGICO',
  'MÉDICO',
  'MÉDICO ESPECIALISTA',
  'MÉDICO VETERINARIO',
  'MICROBIÓLOGO',
  'NUTRICIONISTA',
  'ODONTÓLOGO',
  'OPTÓMETRA',
  'PSICÓLOGO',
  'RADIÓLOGO',
  'TECNÓLOGO EN ATENCIÓN PREHOSPITALARIA',
  'TECNÓLOGO EN RADIOLOGÍA',
  'TERAPEUTA OCUPACIONAL',
  'TECNÓLOGO EN SALUD OCUPACIONAL',

  // Ingeniería
  'INGENIERO AERONÁUTICO',
  'INGENIERO AGRÍCOLA',
  'INGENIERO AGROINDUSTRIAL',
  'INGENIERO AMBIENTAL',
  'INGENIERO BIOMÉDICO',
  'INGENIERO CIVIL',
  'INGENIERO DE ALIMENTOS',
  'INGENIERO DE MINAS',
  'INGENIERO DE PETRÓLEOS',
  'INGENIERO DE SISTEMAS',
  'INGENIERO DE TELECOMUNICACIONES',
  'INGENIERO ELÉCTRICO',
  'INGENIERO ELECTRÓNICO',
  'INGENIERO FORESTAL',
  'INGENIERO INDUSTRIAL',
  'INGENIERO MECÁNICO',
  'INGENIERO MECATRÓNICO',
  'INGENIERO METALÚRGICO',
  'INGENIERO QUÍMICO',
  'INGENIERO TOPOGRÁFICO',

  // Tecnologías
  'TECNÓLOGO EN ELECTRICIDAD',
  'TECNÓLOGO EN ELECTRÓNICA',
  'TECNÓLOGO EN GESTIÓN EMPRESARIAL',
  'TECNÓLOGO EN LOGÍSTICA',
  'TECNÓLOGO EN MANTENIMIENTO INDUSTRIAL',
  'TECNÓLOGO EN SISTEMAS',
  'TÉCNICO ELECTRICISTA',
  'TÉCNICO EN REFRIGERACIÓN',
  'TÉCNICO MECÁNICO',
  'TÉCNICO EN SOLDADURA',

  // Administración y Negocios
  'ADMINISTRADOR DE EMPRESAS',
  'ADMINISTRADOR DE SALUD',
  'ADMINISTRADOR FINANCIERO',
  'ADMINISTRADOR PÚBLICO',
  'CONTADOR PÚBLICO',
  'ECONOMISTA',
  'FINANCIERO',
  'NEGOCIADOR INTERNACIONAL',

  // Ciencias Sociales y Humanas
  'ABOGADO',
  'ANTROPÓLOGO',
  'COMUNICADOR SOCIAL',
  'FILÓSOFO',
  'GEÓGRAFO',
  'HISTORIADOR',
  'PERIODISTA',
  'POLITÓLOGO',
  'PSICÓLOGO CLÍNICO',
  'PSICÓLOGO ORGANIZACIONAL',
  'SOCIÓLOGO',
  'TRABAJADOR SOCIAL',

  // Educación
  'DOCENTE',
  'EDUCADOR ESPECIAL',
  'LICENCIADO EN BIOLOGÍA',
  'LICENCIADO EN CIENCIAS SOCIALES',
  'LICENCIADO EN EDUCACIÓN FÍSICA',
  'LICENCIADO EN ESPAÑOL Y LITERATURA',
  'LICENCIADO EN FILOSOFÍA',
  'LICENCIADO EN FÍSICA',
  'LICENCIADO EN MATEMÁTICAS',
  'LICENCIADO EN MÚSICA',
  'LICENCIADO EN QUÍMICA',

  // Ciencias Básicas
  'BIÓLOGO',
  'FÍSICO',
  'GEÓLOGO',
  'MATEMÁTICO',
  'QUÍMICO',
  'ZOOTECNISTA',

  // Artes y Diseño
  'ARQUITECTO',
  'DISEÑADOR DE MODAS',
  'DISEÑADOR GRÁFICO',
  'DISEÑADOR INDUSTRIAL',
  'DISEÑADOR INTERIOR',
  'MÚSICO',
  'PUBLICISTA',

  // Agronomía
  'AGRÓNOMO',
  'INGENIERO AGROFORESTAL',
  'MÉDICO VETERINARIO Y ZOOTECNISTA',

  // Otras
  'BOMBERO',
  'CHEF',
  'GASTRÓNOMO',
  'MARINERO',
  'PILOTO',
  'TECNÓLOGO EN GASTRONOMÍA',
  'TOPÓGRAFO',
].sort();
